export default {
  all (context) {
    context.loading = true
    context.$http.get('apps').then(response => {
      context.apps = response.body.data
      context.loading = false
    })
  },
  get (context, id) {
    context.$http.get('apps/' + id).then(response => {
      context.app = response.body.data[0]
    })
  },
  destroy (context, id) {
    context.$http.delete('apps/' + id).then(response => {
      context.destroyModal = false
      context.destroyed = true
    })
  },
  update (context, id, app) {
    var body = { app: app }
    context.$http.put('apps/' + id, body).then(response => {
      context.saveModal = false
      context.updated = true
    })
  },
  create (context, app) {
    var body = { app: app }
    context.$http.post('apps', body).then(response => {
      context.app = response.body.data[0]
      context.saveModal = false
      context.created = true
      context.isNew = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/apps.js